import { CLEAR_WALK_IN_CONSENT_QA_DATA, GET_WALK_IN_CONSENT_QA_DATA } from "../../constants/walk-in-consent-qa/walkInConsentQAConst";


const initialState = {
    questionAnswerData: [],
};

export default function walkInConsentQAReducer(state = initialState, action) {
    switch (action.type) {

        case GET_WALK_IN_CONSENT_QA_DATA:
            return {
                ...state,
                questionAnswerData: action.payload,
            };

        case CLEAR_WALK_IN_CONSENT_QA_DATA:
            return {
                ...state,
                questionAnswerData: [],
            };

        default:
            return state;
    }

}



